import { render, staticRenderFns } from "./OrderDialog.vue?vue&type=template&id=1d05ae40&scoped=true&"
import script from "./OrderDialog.vue?vue&type=script&lang=js&"
export * from "./OrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d05ae40",
  null
  
)

export default component.exports